export const getJournalistURL = (url) => {
    return `${process.env.REACT_APP_ASYNC_SCRAPER_URL}/${url}`
}